module.exports = __webpack_public_path__ + "img/3.3a03b23.jpg";